import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { FieldValues } from "react-hook-form";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { corporateHost } from "~/Utils";
import { SingleCabinLuggagePolicySection1 } from "../SingleCabinLuggagePolicySection/SingleCabinLuggagePolicySection1";
import { SingleCabinLuggagePolicySection2 } from "../SingleCabinLuggagePolicySection/SingleCabinLuggagePolicySection2";
import { LagsSection1 } from "../LagsSection/LagsSection1";
import { LagsSection2 } from "../LagsSection/LagsSection2";
import { RestrictedItemsSections } from "../RestrictedItemsSection/RestrictedItemsSections";
import { RestrictedItemsSectionsList } from "../RestrictedItemsSection/RestrictedItemsSectionsList";

export const RestrictedItems = () => {
  const query = useQuery();
  const navigate = useNavigate();
  
  const travellersInfoCard =[
    {
      label: "Checked-In & Cabin Restrictions Content",
      key: "restrictedItemsCheckedInCabinRestrictionsContent",
      children: <RestrictedItemsSections />
    },
    {
      label: "Checked-In & Cabin Restrictions Image",
      key: "restrictedItemsCheckedInCabinRestrictionsImage",
      children: <RestrictedItemsSectionsList />
    },
    {
        label: "Cabin-Only Restrictions Content",
        key: "restrictedItemsCabinOnlyRestrictionsContent",
        children: <RestrictedItemsSections />
    },
    {
        label: "Cabin-Only Restrictions Image",
        key: "restrictedItemsCabinOnlyRestrictionsImage",
        children: <RestrictedItemsSectionsList />
    }
  ]


  return (
    // <ContentWrapper>
      <Tabs
      activeKey={query?.get("fourthChildActiveTab") || ""}
      items={travellersInfoCard}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${query.get('subActiveTab')}&thirdChildActiveTab=${query.get('thirdChildActiveTab')}&fourthChildActiveTab=${activeKey}`);
      }}
    ></Tabs>
    // </ContentWrapper>
  );
};
